import { render, staticRenderFns } from "./EffarigTab.vue?vue&type=template&id=0883caed&scoped=true&"
import script from "./EffarigTab.vue?vue&type=script&lang=js&"
export * from "./EffarigTab.vue?vue&type=script&lang=js&"
import style0 from "./EffarigTab.vue?vue&type=style&index=0&id=0883caed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0883caed",
  null
  
)

export default component.exports